import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { Message } from "../../types/types";
import { cleanHtml } from "../string/cleanHtml";

type GetPromoMessagingResponse = {
  promoDrawerMessages: Message[];
  pageMessages: Message[];
  featureDrawerMessages: Message[];
  additionalMessages: Message[];
};

function cleanMessage(message: Message) {
  return {
    ...message,
    description: cleanHtml(message.description) || null,
  };
}

function isIFCMessage(message: Message) {
  return /interest free credit/gim.test(message.title);
}

function concatIfUnique(arr: Array<Message>, item: Message) {
  return arr.find(
    ({ title, description }) =>
      title === item.title && description === item.description,
  )
    ? arr
    : arr.concat(item);
}

function addTo(
  acc: GetPromoMessagingResponse,
  message: Message,
  section:
    | "pageMessages"
    | "promoDrawerMessages"
    | "featureDrawerMessages"
    | "additionalMessages",
) {
  return {
    ...acc,
    [section]: concatIfUnique(acc[section], message),
  };
}

const isPromotionalMessage = (
  message: NonPromotionalMessage | PromotionalMessage,
): message is PromotionalMessage => {
  return (message as PromotionalMessage).promotionGroup !== undefined;
};

export const getPromoMessaging = (
  messages: Message[],
  isVersionTwoPromoDrawer: boolean,
  isCobeCreditOffers = false,
): GetPromoMessagingResponse =>
  messages.map(cleanMessage).reduce(
    (
      acc: GetPromoMessagingResponse,
      message: NonPromotionalMessage | PromotionalMessage,
    ) => {
      const { title, type, description } = message;
      if (isCobeCreditOffers && isIFCMessage(message)) {
        return acc;
      }

      if (isPromotionalMessage(message)) {
        if (isVersionTwoPromoDrawer) {
          const pricingGroups = [
            "Save",
            "Reduced To Clear",
            "Special Buy",
            "Price Match",
            "Introductory Offer",
          ];

          if (pricingGroups.includes(message.promotionGroup)) {
            return addTo(acc, message, "pageMessages");
          } else {
            return addTo(acc, message, "promoDrawerMessages");
          }
        } else {
          if (description === null || description!.length === 0) {
            return addTo(acc, message, "pageMessages");
          } else {
            return addTo(acc, message, "promoDrawerMessages");
          }
        }
      }

      switch (type) {
        case "feature": {
          if (title === "60 Night Comfort Trial") {
            return addTo(acc, message, "pageMessages");
          }
          return addTo(acc, message, "featureDrawerMessages");
        }
        case "endorsement": {
          return addTo(acc, message, "featureDrawerMessages");
        }
        case "additional": {
          return addTo(acc, message, "additionalMessages");
        }
        default: {
          return addTo(acc, message, "promoDrawerMessages");
        }
      }
    },
    {
      promoDrawerMessages: [],
      pageMessages: [],
      featureDrawerMessages: [],
      additionalMessages: [],
    },
  );
